import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/reverse-sales-tax-calculator',
  component: () => import('../../routes/ReverseSalesTaxCalculator.svelte'),
  card: {
    id: 'reverse-sales-tax',
    title: 'Reverse Sales Tax Calculator',
    description: 'Calculate the pre-tax price and tax amount from a total price that includes sales tax.',
    icon: 'receipt_long',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/reverse-sales-tax-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Reverse Sales Tax Calculator – Find Pre-Tax Price from Total',
    description: 'Free reverse sales tax calculator to find the pre-tax price and tax amount from any total price. Enter the total amount paid and the tax rate to see the original price before tax.',
  },
};

export default meta;